/** GBWaps 站点常量（Vue 实现） */
export const SITE_NAME = 'GBWaps';
export const SITE_DOMAIN = 'gbwaps.com';
export const SITE_URL = 'https://gbwaps.com';
export const SUPPORT_EMAIL = 'support@gbwaps.com';
/** 站点 Logo（青绿渐变 GB 圆角标，全站统一 · public/images/gbwaps/logo.webp） */
export const LOGO_PATH = '/images/gbwaps/logo.webp';
export const LOGO_URL = LOGO_PATH;
export const LOGO_ABSOLUTE_URL = `${SITE_URL}${LOGO_PATH}`;

/** 顶栏 / favicon / Apple 触控图标 */
export const SITE_ICON_LINKS = [
	{ rel: 'icon', type: 'image/webp', href: LOGO_PATH },
	{ rel: 'apple-touch-icon', href: LOGO_PATH },
];

export const MAIN_NAV = [
	{ label: 'Home', path: '/' },
	{ label: 'Download', path: '/download/' },
	{ label: 'Install', path: '/install-gbwhatsapp/' },
	{ label: 'Update', path: '/gbwhatsapp-update/' },
	{ label: 'Features', path: '/features/' },
	{ label: 'Anti-Ban', path: '/anti-ban/' },
	{ label: 'Troubleshooting', path: '/troubleshooting/' },
	{ label: 'FAQ', path: '/faq/' },
	{ label: 'Blog', path: '/blog/' },
];

export const FOOTER_NAV = [
	{ label: 'Home', path: '/' },
	{ label: 'About', path: '/about/' },
	{ label: 'Contact Us', path: '/contact-us/' },
	{ label: 'Privacy Policy', path: '/privacy-policy/' },
	{ label: 'Terms of Service', path: '/terms-of-service/' },
	{ label: 'Disclaimer', path: '/disclaimer/' },
];

export const ORGANIZATION_SCHEMA = {
	'@context': 'https://schema.org',
	'@type': 'Organization',
	name: SITE_NAME,
	url: SITE_URL,
	logo: LOGO_ABSOLUTE_URL,
	contactPoint: {
		'@type': 'ContactPoint',
		email: SUPPORT_EMAIL,
		contactType: 'customer service',
	},
};

/** 生成路由 meta（SSR head 使用） */
export function createPageMeta(options = {}) {
	const { title, description, keywords, path = '/' } = options;
	const canonicalPath = path === '/' ? '/' : path.endsWith('/') ? path : `${path}/`;
	return {
		appname: 'GBWhatsApp',
		title: title || `${SITE_NAME} | GB WhatsApp Guide`,
		description:
			description ||
			'Download GB WhatsApp APK, install guides, features, anti-ban tips and troubleshooting on GBWaps.',
		keywords: keywords || 'gbwhatsapp, gb whatsapp, gb whatsapp download, gb whatsapp apk',
		link: [
			...SITE_ICON_LINKS,
			{ rel: 'canonical', href: `${SITE_URL}${canonicalPath === '/' ? '/' : canonicalPath}` },
		],
	};
}
